import styled from 'styled-components';
import StyleData from '../../../utilities/StyleData';

export const Root = styled.div<{ $mobile: boolean }>`
  display: flex;
  ${(props) => (props.$mobile ? 'flex-direction: column' : '')};
  align-items: ${(props) => (props.$mobile ? 'start' : 'center')};
  gap: ${(props) => (props.$mobile ? StyleData.spacing.xs : StyleData.spacing.md)};
  font-size: ${StyleData.fsize.sm};
`;

export const Label = styled.p`
  font-family: ${StyleData.font.primary};
  color: ${StyleData.color.smoothGrey};
  margin: 0;
`;
